<template>
  <svg class="icon" aria-hidden="true" :style="style">
    <use v-bind:xlink:href="xlink"></use>
  </svg>
</template>

<script>
export default {
  name: "c-icon",
  props: {
    name: String,
    color: {
      type: String,
      default: ""
    },
    // 带单位的 css width
    width: String,
    height: String,
    // 同时设置 width 和 height，单位 em. 优先级低于 width 和 height
    size: [Number, String]
  },
  computed: {
    xlink() {
      return "#" + this.name;
    },
    style() {
      let style = {};
      if (this.color) {
        style.color = this.color;
      }
      if (this.width) {
        style.width = this.width;
      }
      if (this.height) {
        style.height = this.height;
      }
      if (this.size) {
        if (!this.width) {
          style.width = this.size + "em";
        }
        if (!this.height) {
          style.height = this.size + "em";
        }
      }
      return style;
    }
  }
};
</script>

<style>
</style>
